import React from 'react';
import "./spin.scss"
import { NAME_SERVER } from '../../../Utils/NAME_HOST';
const Spin = () => {
    return (
        <div className="spin-wrapper">
            <img src={NAME_SERVER+"/assets/logo_s.png"} className='swing' width={100}/>
            
        </div>
    );
};

export default Spin;